import { render, staticRenderFns } from "./SpecialAttentionModal.vue?vue&type=template&id=08a73481&scoped=true"
import script from "./SpecialAttentionModal.vue?vue&type=script&lang=js"
export * from "./SpecialAttentionModal.vue?vue&type=script&lang=js"
import style0 from "./SpecialAttentionModal.vue?vue&type=style&index=0&id=08a73481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a73481",
  null
  
)

export default component.exports